import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import api from "../services/axiosInstance";
import { backendPort } from '../components/Fungsiku';
import { useNotification } from './NotifPopup';
import { useConfirm } from './ModalConfirm';
import {sortData} from '../components/Fungsiku';
import {formBulk} from '../components/ExcelFormBulk';
import {UploadBulk} from '../components/ExcelUploadBulk';
import {Showing} from '../components/ShowingTabel';

const REQ_GROUP_PAGE20_SUBMIT = 'page20-bulk-submit';

export function PageKonten20({ globalOpsi, authIdentity = {}, token}){
  const opsiCabang = globalOpsi?.opsiCabang || [];
  const opsiSumber = globalOpsi?.opsiSumber || [];
  const opsiSubAkun = globalOpsi?.opsiSubAkun || [];
  const fileRef = useRef(null);
  const [dataUpload, setDataUpload] = useState(null);
  const [dataUploadAll, setDataUploadAll] = useState(null);
  const [canUpload, setCanUpload] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { showNotif } = useNotification(); 
  const { showConfirm } = useConfirm();
  const kodeCabangUser = String(authIdentity?.kode_cabang || "").trim();
  const namaUser = String(authIdentity?.nama || "").trim();
  const actorIdentity = { ...(authIdentity || {}) };
  const isPusat = kodeCabangUser === 'C-1';
  const [jenis, setJenis] = useState(isPusat ? "drp" : "nrm");
  useEffect(() => {
    setJenis(isPusat ? "drp" : "nrm");
  }, [isPusat]);
  const opsiSumberValues = (Array.isArray(opsiSumber) ? opsiSumber : [])
    .map((item) => {
      if (typeof item === 'string' || typeof item === 'number') return String(item).trim();
      if (item && typeof item === 'object') return String(item.sumber ?? '').trim();
      return '';
    })
    .filter(Boolean);
  
  const handleSubmitBulk = async () => {
    if (isSubmitting) return;
    try
    {
      if(!dataUpload?.valid || dataUpload?.valid?.length === 0) {
      showNotif("error","Data Kosong"); 
      setCanUpload(false);
      if (fileRef.current) {
      fileRef.current.value = "";
      }
      return;};

      const data = dataUpload?.valid?.map((x) => {  
        console.log("x.cabang =", x.cabang, opsiCabang);

        const inputNominal = ()=>{
          if(jenis === 'kor' || jenis === 'drp') 
            {return Number(x.nominal)}
          else if(jenis === 'nrm' || jenis === 'kdr')
            {return Number(x.nominal) * -1}
          else {return 'eror'} //kasih string biar eror
        }

        if(jenis==='drp' || jenis === 'kdr'){
          return {
                    kode_cabang   : x.cabang,
                    tanggal       : x.tanggal,
                    sumber        : x.sumber,
                    akun          : x.akun,
                    subakun       : x.subakun,
                    nominal       : inputNominal(),
                    catatan       : x.catatan ?? "",
                    user          : namaUser,
                    jenis         : jenis
                 }
        } 
        else {
          if(isPusat){
            return {
                    kode_cabang   : x.cabang ?? kodeCabangUser,
                    tanggal       : x.tanggal,
                    sumber        : x.sumber,
                    akun          : x.akun,
                    subakun       : x.subakun,
                    nominal       : inputNominal(),
                    catatan       : x.catatan ?? "",
                    user          : namaUser,
                    jenis         : jenis
                 }
          } else {
            return {
                    kode_cabang   : kodeCabangUser,
                    tanggal       : x.tanggal,
                    sumber        : x.sumber,
                    akun          : x.akun,
                    subakun       : x.subakun,
                    nominal       : inputNominal(),
                    catatan       : x.catatan ?? "",
                    user          : namaUser,
                    jenis         : jenis
                 }
          }
          
        }

         
      });
      setIsSubmitting(true);
      api.cancelPendingRequests({
        group: REQ_GROUP_PAGE20_SUBMIT,
        reason: 'submit petty bulk terbaru',
      });
      await api.post(
        `${backendPort}/api/main/petty_bulk`,
          { data },
          {
            headers: {Authorization: `Bearer ${token}`},
            requestGroup: REQ_GROUP_PAGE20_SUBMIT,
            timeout: 120000,
          }
        );
    
      showNotif('success', 'Upload Data berhasil');
      setDataUpload([]);
      setDataUploadAll([]);
      setCanUpload(false);
      if (fileRef.current) {
      fileRef.current.value = "";
      }
    } catch (e){
        if (api.isCanceledError(e)) return;
        console.error(e);
        showNotif('error', 'Upload bulk gagal');
        if (fileRef.current) {
          fileRef.current.value = "";
        }
        setCanUpload(false);
    } finally {
      setIsSubmitting(false);
    }}
  
  const getDataBulk = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      setDataUpload(null);
      return;
    }
    const opsSumber = opsiSumberValues;
    const opsSubAkun = opsiSubAkun.map(x=> {return `${x.akun} : ${x.subakun}`});

    try{
      const result = await UploadBulk(file, jenis, { ...actorIdentity, kode_cabang: kodeCabangUser, nama: namaUser }, opsiCabang, opsSumber, opsSubAkun);
      setDataUpload(result);
      setDataUploadAll(result);
      setCanUpload(true);  
      console.log("isiDataUpload =", result);
    }catch(e){
      console.error(e);
      showNotif('error', 'File tidak valid');
    }


  }

  const formatRibu = (value) => {
    if (value === null || value === undefined) return '0';
    return new Intl.NumberFormat('id-ID').format(Number(value));
  };
  
return <>
    <div className="card-body p-0"> 
                            <div className="col-md-9">
                            </div>
                            <div className="col-md-3">
                              <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => {
                                      const opsSubAkun = opsiSubAkun.map(x=> {return `${x.akun} : ${x.subakun}`});
                                      console.log("opsiCabang =", opsiCabang);
                                      showConfirm({
                                        title: 'Formulir Bulk Transaksi',
                                        message: 'Lanjutkan Download?',
                                        onConfirm: () => {
                                          formBulk(jenis, { ...actorIdentity, kode_cabang: kodeCabangUser, nama: namaUser }, opsiCabang, opsiSumber, sortData(opsSubAkun));
                                        }
                                      });
                                      }
                                  }>FORMULIR</button>
                            </div>
                          </div>
                          <div className="card-body p-0">  
                            <div className="row my-2 mx-0">
                                <div className='card card-body-0'>
                                  {/*UPLOAD*/}
                                  <div className='row my-2'>
                                    <div className="fs-6 fs-light col-md-8 my-2">Jenis Transaksi</div>
                                    <div className="col-md-4 justify-content-end">
                                      <select className="form-control text-start justify-content-start  border-danger"
                                          value={jenis}
                                          onChange={(e) => {setJenis(e.target.value)}}
                                      >
                                        {isPusat ? <option value="drp">Dropping Dana</option> : null}
                                        {isPusat ? <option value="kdr">Koreksi Dropping</option> : null}
                                        <option value="nrm">Transaksi Belanja</option>
                                        <option value="kor">Koreksi Belanja</option>
                                  </select>
                                  </div>
                                  </div>
                                  <div className='row my-2'>
                                    <div className="fs-6 fs-light col-md-8 my-2">Total Nominal</div>
                                    <div className="col-md-4 justify-content-end">
                                      <input
                                        className="form-control text-end justify-content-end"
                                        value={formatRibu(dataUpload?.total ?? 0)}
                                        disabled
                                      />
                                    </div>
                                  </div>
                                  <div className='row my-2'>
                                    <div className="fs-6 fs-light col-md-8 my-2">Jumlah Transaksi Valid</div>
                                    <div className="col-md-4 justify-content-end">
                                      <input
                                        className="form-control text-end justify-content-end"
                                        value={dataUpload?.valid?.length ?? 0}
                                        disabled
                                      />
                                    </div>
                                  </div>
                                  <div className='row my-2'>
                                    <div className="fs-6 fs-light col-md-8 my-2">Jumlah Transaksi Tidak Valid</div>
                                    <div className="col-md-4 justify-content-end">
                                      <input
                                        className="form-control text-end justify-content-end"
                                        value={dataUpload?.invalid?.length ?? 0}
                                        disabled
                                      />
                                    </div>
                                  </div>
                                  <div className="row justify-content-between align-items-center my-2">
                                    <div className="col-md-8 fs-6 fs-light">
                                      <input 
                                        type="file" 
                                        ref={fileRef}
                                        onChange={getDataBulk} 
                                        accept=".xlsx,.xls" /> 
                                    </div>
                                    <div className="row col-md-4">

                                          <div className="col-md-6">
                                              <button
                                              type="button"
                                              className="btn btn-secondary text-white"
                                              onClick={() => {
                                                  setDataUpload([]);
                                                  setDataUploadAll([]);
                                                  setCanUpload(false);
                                                  if (fileRef.current) {
                                                  fileRef.current.value = "";
                                                  }
                                              }}
                                              >
                                              CLEAR
                                              </button>
                                          </div>

                                          {/*EXCEL*/}
                                          <div className="col-md-6">
                                              <button
                                              type="button"
                                              className="btn btn-danger"
                                              disabled={!canUpload}
                                              onClick={() => {
                                                showConfirm({
                                                  title: 'Submit Bulk',
                                                  message: 'Pastikan Transaksi sudah benar. Lanjutkan?',
                                                  onConfirm: () => {
                                                    handleSubmitBulk();;
                                                  }
                                              });
                                              }}
                                              > UPLOAD</button>
                                          </div>
                                          
                                    </div>  
                                  </div>
                            </div>
                          </div>       
                                  {/*TABEL SHOW*/}     
                             {(!isPusat) && <Showing dataTabel = {dataUpload} type={'dataUpload'} opsiCabang={opsiCabang}/>}
                             {(isPusat) && <Showing dataTabel = {dataUploadAll} type={'dataUploadAll'} opsiCabang={opsiCabang}/>} 
                        </div>
</>
}
